import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';



function Search() {
    return (
      <>
        <Container style={{margin: "20px"}}>
            <Form className="d-flex col-sm-10">
                <Form.Control
                    type="search"
                    placeholder="Search for products"
                    className="me-2"
                    aria-label="Search"
                />
                <Button variant="primary">Search</Button>
            </Form>  
        </Container>
      </>
    );
}

export default Search;